import iconDarkSvg from 'src/assets/icon-dark.svg';
import iconGradientPng from 'src/assets/icon-gradient.png';
import iconWhiteSvg from 'src/assets/icon-white.svg';
import logoDarkSvg from 'src/assets/logo-dark.svg';
import logoGradientPng from 'src/assets/logo-gradient.png';
import logoMetallicPng from 'src/assets/logo-metallic.png';
import logoWhiteSvg from 'src/assets/logo-white.svg';

export const logoDark = logoDarkSvg;
export const logoWhite = logoWhiteSvg;
export const logoGradient = logoGradientPng;
export const logoMetallic = logoMetallicPng;
export const iconDark = iconDarkSvg;
export const iconWhite = iconWhiteSvg;
export const iconGradient = iconGradientPng;
